<template>
  <!--使用 pdfvuer 实现 滑动浏览 单印章-->
  <div id="boxContent">
    <div id="contentArea" class="centerArea">
      <pdf
        ref="wrapper"
        :src="pdfData"
        v-for="i in numPages"
        :key="i"
        :id="i"
        :page="i"
        :scale="1"
        :resize="true"
      >
      <loading>
        加载中
      </loading>
      </pdf>
    </div>
    <div class="rightArea">
      <ul>
        <li>{{ page }}/{{ numPages }} 页</li>
        <li>
          <el-button type="primary" size="mini" @click.stop="prePage"
            >上一页</el-button
          >
        </li>
        <li>
          <el-button type="primary" size="mini" @click.stop="nextPage"
            >下一页</el-button
          >
        </li>
        <li>
          <span>跳到</span>
          <el-input
            class="input-page"
            size="mini"
            v-model="inputPage"
            @keyup.enter="pageChange"
            input-style="padding: 0 5px 0 5px;"
          />
          <span>页</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {ElLoading} from 'element-plus'
import pdf from "pdfvuer"; // pdfvuer 版本为@1.6.1
export default {
  name: "PdfCanvas",
  components: {
    pdf,
  },
  data() {
    return {
      page: 1, // 当前页
      numPages: 0, // 总页数
      pdfData: undefined,
      inputPage: 1, // 输入的页码
      loading: false,
    };
  },
  mounted() {
    this.showLoading();
    this.getPdf();
    window.addEventListener("scroll", this.handleScroll, true);
    this.closeLoading();
  },
  watch: {
    show: function (s) {
      if (s) {
        this.getPdf();
      }
    },
  },
  methods: {
    // 获取 pdf 信息
    showLoading() {
        this.loading=ElLoading.service({text: "预览报告加载中", background: "rgba(0, 0, 0, 0.8)"})
    },
    closeLoading() {
        this.loading.close()
    },
    getPdf() {
      this.pdfData = pdf.createLoadingTask(this.url);
      this.pdfData
        .then((pdf) => {
          this.numPages = pdf.numPages;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 滚动事件 滚动时更新页码
    handleScroll() {
      let scrollTop = this.getScrollTop(); // 滚动高度
      let onePageHeight = this.getAttributeValue("page", "height"); // 单页面高度
      this.page = Math.round(scrollTop / onePageHeight) + 1;
      // this.inputPage = this.page
    },
    // 获取滚动高度
    getScrollTop() {
      let scroll_top = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scroll_top = document.documentElement.scrollTop;
      } else if (document.body) {
        scroll_top = document.body.scrollTop;
      }
      return scroll_top;
    },
    // 滚动到固定位置
    goTo(target) {
      let scrollT =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollT > target) {
        let timer = setInterval(function () {
          let scrollT =
            document.body.scrollTop || document.documentElement.scrollTop;
          let step = Math.floor(-scrollT / 6);
          document.documentElement.scrollTop = document.body.scrollTop =
            step + scrollT;
          if (scrollT <= target) {
            document.body.scrollTop = document.documentElement.scrollTop =
              target;
            clearTimeout(timer);
          }
        }, 20);
      } else if (scrollT === 0) {
        let timer = setInterval(function () {
          let scrollT =
            document.body.scrollTop || document.documentElement.scrollTop;
          let step = Math.floor((300 / 3) * 0.7);
          document.documentElement.scrollTop = document.body.scrollTop =
            step + scrollT;
          if (scrollT >= target) {
            document.body.scrollTop = document.documentElement.scrollTop =
              target;
            clearTimeout(timer);
          }
        }, 20);
      } else if (scrollT < target) {
        let timer = setInterval(function () {
          let scrollT =
            document.body.scrollTop || document.documentElement.scrollTop;
          let step = Math.floor(scrollT / 6);
          document.documentElement.scrollTop = document.body.scrollTop =
            step + scrollT;
          if (scrollT >= target) {
            document.body.scrollTop = document.documentElement.scrollTop =
              target;
            clearTimeout(timer);
          }
        }, 20);
      } else if (target === scrollT) {
        return false;
      }
    },
    // 上一页
    prePage() {
      let page = this.page;
      page = page > 1 ? page - 1 : 1;
      this.page = page;
      this.changeScrollTop();
    },
    // 下一页
    nextPage() {
      let page = this.page;
      page = page < this.numPages ? page + 1 : this.numPages;
      this.page = page;
      this.changeScrollTop();
    },
    // 根据输入的页码跳转页面
    pageChange() {
      let reg = /^[1-9]\d*$/;
      if (!reg.test(this.inputPage)) {
        this.$message.error("请输入正确的页码");
        return;
      }
      this.inputPage > this.numPages
        ? (this.page = this.numPages)
        : (this.page = ~~this.inputPage);
      this.inputPage < 1 ? (this.page = 1) : (this.page = ~~this.inputPage);
      this.changeScrollTop();
    },
    // 根据页码变化修改页面滚动距离
    changeScrollTop() {
      let onePageHeight =
        document.getElementById("contentArea").offsetHeight / this.numPages;
      let scrollTo = onePageHeight * (this.page - 1);
      this.goTo(scrollTo);
    },

    // 获取节点的某个属性值 只适用于获取 px 相关数据
    getAttributeValue(className, attr) {
      let pageDiv = document.querySelector("." + className);
      let attrsValue = getComputedStyle(pageDiv);
      let attrVal = attrsValue[attr];
      return Number(attrVal.substr(0, attrVal.length - 2)); // 截取掉 px
    },
  },
  props: {
    url: {
      type: String,
      default() {
        return undefined;
      },
    },
  },
};
</script>
<style lang="less">
#boxContent {
  width: 100%;
}
.rightArea {
  position: fixed;
  right: 0;
  top: 50%;
  width: 70px;
  ul {
    padding: 0;
    border-right: solid 3px #409eff;
    font-size: 13px;
  }
  .input-page {
    width: 25px;
  }
}
</style>
